import { Text, View } from '@mirai/ui';
import React from 'react';

import * as style from './routes.module.css';

export const Rooms = () => (
  <>
    <View tag="section" className={[style.section, style.box, style.accent]}>
      <View className={style.wrapper}>
        <Text bold headline level={1}>
          Rooms
        </Text>
        <Text>Book this room now!</Text>
      </View>
    </View>
    <View className={[style.wrapper, style.box]}>
      <View data-mirai-component="rooms" data-id={new URLSearchParams(location.search).get('roomId') || '63971'} />
    </View>
  </>
);
